export default "__VITE_ASSET__BynID$IB__"